<template>
    <div class="columns">
        <div class="column" v-if="!!chosenConfig?.id">
            <div class="field">
                <label class="label">{{ translate("pricing.chosen_configuration") }}</label>
                <div class="field is-grouped">
                    <div class="control is-expanded">
                        <input class="input" type="text" :value="displayNameOfChosenConfig" readonly />
                    </div>
                    <div class="control">
                        <button class="button is-text" @click="changePaymentGatewayConfiguration">
                            <span class="icon">
                                <i class="fas fa-edit"></i>
                            </span>
                            <span>{{ translate("common.change") }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <div>
                <div class="field">
                    <label class="label">{{ translate("pricing.choose_available_currencies") }}</label>
                    <div class="control">
                        <Checkbox2 v-model="eurCurrency"> EUR</Checkbox2>
                    </div>
                    <div class="control">
                        <Checkbox2 v-model="plnCurrency"> PLN</Checkbox2>
                    </div>
                    <div class="control">
                        <Checkbox2 v-model="sgdCurrency"> SGD</Checkbox2>
                    </div>
                    <div class="control">
                        <Checkbox2 v-model="brlCurrency">BRL</Checkbox2>
                    </div>
                    <div class="control">
                        <Checkbox2 v-model="gbpCurrency"> GBP </Checkbox2>
                    </div>
                </div>
            </div>
        </div>
        <div class="column" v-else>
            <p class="has-text-centered mb-5" v-html="translate('pricing.not_configured_yet')"></p>
            <div class="is-flex is-justify-content-space-evenly is-align-items-center">
                <figure class="image przelewy-logo-width" @click="switchToP24Configuration">
                    <img src="https://static.martialmatch.com/images/help-center/b701c54b.png" />
                </figure>
                <figure class="image stripe-logo" @click="switchToStripeConfiguration">
                    <img src="https://static.martialmatch.com/images/help-center/90e80a11.png" />
                </figure>
                <figure class="image asaas-logo" @click="switchToAsaasConfiguration">
                    <img src="https://static.martialmatch.com/images/help-center/25bdf5a2.jpg" />
                </figure>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import Checkbox2 from "../../Common/Checkbox2.vue";
    import { translate } from "../../Common/translations";
    import { usePaymentGatewayConfigStore } from "../pricingSetupApp";

    const paymentGatewayConfigStore = usePaymentGatewayConfigStore();

    const chosenConfig = computed(() => paymentGatewayConfigStore.chosenConfig);
    const eurCurrency = computed({
        get() {
            return paymentGatewayConfigStore.currenciesMap["EUR"];
        },
        set(value) {
            paymentGatewayConfigStore.currenciesMap["EUR"] = value;
        },
    });
    const sgdCurrency = computed({
        get() {
            return paymentGatewayConfigStore.currenciesMap["SGD"];
        },
        set(value) {
            paymentGatewayConfigStore.currenciesMap["SGD"] = value;
        },
    });
    const plnCurrency = computed({
        get() {
            return paymentGatewayConfigStore.currenciesMap["PLN"];
        },
        set(value) {
            paymentGatewayConfigStore.currenciesMap["PLN"] = value;
        },
    });
    const brlCurrency = computed({
        get() {
            return paymentGatewayConfigStore.currenciesMap["BRL"];
        },
        set(value) {
            paymentGatewayConfigStore.currenciesMap["BRL"] = value;
        },
    });
    const gbpCurrency = computed({
        get() {
            return paymentGatewayConfigStore.currenciesMap["GBP"];
        },
        set(value) {
            paymentGatewayConfigStore.currenciesMap["GBP"] = value;
        },
    });

    const displayNameOfChosenConfig = computed(() => {
        if (chosenConfig.value?.id) {
            return `[${chosenConfig.value.provider}] ${chosenConfig.value.name}`;
        } else {
            return "";
        }
    });

    const switchToP24Configuration = () => {
        paymentGatewayConfigStore.view = "p24_configuration";
    };
    const switchToStripeConfiguration = () => {
        paymentGatewayConfigStore.view = "stripe_configuration";
    };
    function switchToAsaasConfiguration() {
        paymentGatewayConfigStore.view = "asaas_configuration";
    }
    const changePaymentGatewayConfiguration = () => {
        paymentGatewayConfigStore.chosenConfig = null;
    };
</script>

<style scoped>
    .przelewy-logo-width {
        width: 128px;
    }

    .image.przelewy-logo-width {
        transition: all 200ms ease;
        background-color: whitesmoke;
        padding: 5px;
        cursor: pointer;
    }

    .image.przelewy-logo-width:hover {
        background-color: #e0e0e0;
    }

    .image.stripe-logo {
        transition: all 200ms ease;
        background-color: whitesmoke;
        cursor: pointer;
    }

    .image.stripe-logo:hover {
        background-color: #e0e0e0;
    }

    .image.asaas-logo {
        width: 128px;
        cursor: pointer;
    }

    .image.asaas-logo:hover {
        background-color: #e0e0e0;
    }
</style>
